<template>
    <b-carousel id="pws-playlist"
                class="pws-movie-slide"
                :interval="0"
                controls
                indicators
                background="#fff">

        <b-carousel-slide img-blank>
            <div class="wrapper btn-after-youtube-icon" @click="playVideo('40G9xAwJIsQ', ($t('paper.profile_paper_choose_subject')))">
                <img src="/images/pws/slide1-banner.jpg" :alt="$t('paper.profile_paper_choose_subject')">
                <div class="description d-none d-xl-block">
                    <h3 class="title">{{$t('paper.make_profile_paper_1_4_choose_subject')}}</h3>
                    <p>{{$t('profile.high_school_final_year_must_write_profile_paper')}}</p>
                </div>
            </div>
        </b-carousel-slide>

        <b-carousel-slide img-blank>
            <div class="wrapper btn-after-youtube-icon" @click="playVideo('kDeo4h3W0JQ', ($t('paper.profile_paper_construction')))">
                <img src="/images/pws/slide2-banner.jpg" :alt="$t('paper.profile_paper_construction')">
                <div class="description d-none d-xl-block">
                    <h3 class="title">{{$t('paper.make_profile_paper_2_4_construction')}}</h3>
                    <p>{{$t('profile.high_school_final_year_must_write_profile_paper')}}</p>
                </div>
            </div>
        </b-carousel-slide>

        <b-carousel-slide img-blank>
            <div class="wrapper btn-after-youtube-icon" @click="playVideo('KNNPlDuWaMI', ($t('paper.make_profile_paper_do_research')))">
                <img src="/images/pws/slide3-banner.jpg" :alt="$t('paper.make_profile_paper_do_research')">
                <div class="description d-none d-xl-block">
                    <h3 class="title">{{$t('paper.make_profile_paper_3_4_do_research')}}</h3>
                    <p>{{$t('profile.high_school_final_year_must_write_profile_paper')}}</p>
                </div>
            </div>
        </b-carousel-slide>

        <b-carousel-slide img-blank>
            <div class="wrapper btn-after-youtube-icon" @click="playVideo('8cUC_VZ4-0c', ($t('paper.make_profile_paper_refer_sources')))">
                <img src="/images/pws/slide4-banner.jpg" :alt="$t('paper.make_profile_paper_refer_sources')">
                <div class="description d-none d-xl-block">
                    <h3 class="title">{{$t('paper.make_profile_paper_4_4_refer_sources')}}</h3>
                    <p>{$t('profile.high_school_final_year_must_write_profile_paper')}}</p>
                </div>
            </div>
        </b-carousel-slide>
    </b-carousel>
</template>

<script>
export default {
    name: "design-2021-profile-paper-index-carousel-components",
    methods: {
        playVideo(videoId, videoTitle) {
            pws-video-modal
            this.$emit('play-video', videoId, videoTitle);
        }
    }
}
</script>

<style scoped lang="scss">
    .pws-movie-slide ::v-deep {
        .carousel-item {
            > img {
                //max-height: 210px;
                aspect-ratio: 2 / 1.5;
            }
        }

        .carousel-caption {
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            padding: 0;

            .wrapper {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-start;

                .description {
                    padding: map-get($grid-gutter-spacing, twenty-one) map-get($grid-gutter-spacing, fifteen) 0 map-get($grid-gutter-spacing, fifteen);
                    color: $text-color;
                }

                img {
                    width: 100%;
                    object-fit: cover;
                    object-position: center;
                }

                p {
                    font-size: $default-font-size;
                    line-height: 1.3;
                }

                &:before {
                    content: '';
                    background-color: $white;
                    position: absolute;
                    height: 30px;
                    width: 35px;
                    top: calc(48% - 15px);
                    left: calc(50% - 18px);
                }

                &:after {
                    left: calc(50% - 35px);
                    position: absolute;
                    top: calc(50% - 35px);
                    font-size: 3.4375rem;
                    color: $danger;
                    margin: 0;
                }

                &:hover{
                    cursor: pointer ;
                }

            }
        }

        .carousel-indicators {
            li {
                background-color: $primary;
            }
        }

        .carousel-control-prev,
        .carousel-control-next {
            z-index: 15;
            align-items: center;
        }


        .carousel-control-prev-icon,
        .carousel-control-next-icon {
            &:after {
                font-family: 'Font Awesome 5 Pro';
                font-weight: 900;
                font-size: 1.5625rem;
                color: $primary;
            }
        }

        .carousel-control-prev-icon {
            background-image: none;

            &:after {
                content: '\f053';
            }
        }

        .carousel-control-next-icon {
            background-image: none;

            &:after {
                content: '\f054';
            }
        }

    }

    @media(min-width: map-get($grid-breakpoints, 'sm')){
        .pws-movie-slide ::v-deep {
            .carousel-item {
                > img {
                    aspect-ratio: 2 / 1.4;
                }
            }
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'md')){
        .pws-movie-slide ::v-deep {
            .carousel-item {
                > img {
                    aspect-ratio: 2 / 1.3;
                }
            }
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'xl')){
        .pws-movie-slide ::v-deep {
            .carousel-item {
                > img {
                    aspect-ratio: 2 / 1;
                }
            }

            .carousel-caption {
                .wrapper {
                    flex-direction: row;

                    img {
                        width: 75%;
                    }

                    &:before {
                        height: 40px;
                        width: 40px;
                        left: calc(35% - 20px);
                        top: calc(45% - 20px);
                    }

                    &:after {
                        font-size: 4.6875rem;
                        left: calc(35% - 45px);
                        top: calc(48% - 45px);                    }
                }
            }
        }
    }
</style>
